import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ThemeService } from '../../../core/service/theme.service';

@Component({
  selector: 'app-toggle-dark-mode',
  imports: [],
  templateUrl: './toggle-dark-mode.html',
  styleUrl: './toggle-dark-mode.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * A class that provides functionality to toggle between dark and light themes.
 *
 * This class interacts with the `ThemeService` to determine the current theme mode
 * and to toggle the application's theme. The `isDarkMode` property reflects the current
 * theme state, and the `toggleTheme` method switches between dark and light modes.
 *
 * @example
 * const toggle = new ToggleDarkMode();
 * toggle.toggleTheme(); // Switches the theme
 */
export class ToggleDarkMode {
  private themeService = inject(ThemeService);

  isDarkMode = this.themeService.isDarkMode;

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }
}
